// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RequestAction_container__5Hn\\+7{
    width: calc(100% - 50px);
    padding: 22px 24px;
    background-color: #FFF6E9;
    border: 1px solid #FFDFB0;
    border-radius: 25px;
    box-shadow: 0 3px 12px 0 #00000012;
}
@media(max-width: 600px){
    .RequestAction_container__5Hn\\+7{
        padding: 22px 25px;
    }
}
.RequestAction_topSection__-kUa6{
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: 'Gotham Medium', serif;
}
.RequestAction_exclamationCircleOrange__Mtzie{
    height: 20px;
    width: 20px;
    margin-right: 10px;
}
.RequestAction_buttons__fC9WE{
    display: flex;
    margin-top: 18px;
}
.RequestAction_rejectButton__w09LY, .RequestAction_approveButton__ZqJiF{
    height: 38px;
    width: calc(50% - 5px)
}
.RequestAction_rejectButton__w09LY{
    margin-right: 10px;
    color: #EB443F;
    background-color: #FFF6E9;
    border-color: #EB443F66;
}
@media(min-width: 601px) and (max-width: 1080px){
    .RequestAction_rejectButton__w09LY, .RequestAction_approveButton__ZqJiF{
        width: calc(50% - 10px)
    }
    .RequestAction_rejectButton__w09LY{
        margin-right: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/fundraiser/RequestAction.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mCAAmC;AACvC;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ;AACJ;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,uBAAuB;AAC3B;AACA;IACI;QACI;IACJ;IACA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".container{\n    width: calc(100% - 50px);\n    padding: 22px 24px;\n    background-color: #FFF6E9;\n    border: 1px solid #FFDFB0;\n    border-radius: 25px;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n@media(max-width: 600px){\n    .container{\n        padding: 22px 25px;\n    }\n}\n.topSection{\n    display: flex;\n    align-items: center;\n    font-size: 12px;\n    font-family: 'Gotham Medium', serif;\n}\n.exclamationCircleOrange{\n    height: 20px;\n    width: 20px;\n    margin-right: 10px;\n}\n.buttons{\n    display: flex;\n    margin-top: 18px;\n}\n.rejectButton, .approveButton{\n    height: 38px;\n    width: calc(50% - 5px)\n}\n.rejectButton{\n    margin-right: 10px;\n    color: #EB443F;\n    background-color: #FFF6E9;\n    border-color: #EB443F66;\n}\n@media(min-width: 601px) and (max-width: 1080px){\n    .rejectButton, .approveButton{\n        width: calc(50% - 10px)\n    }\n    .rejectButton{\n        margin-right: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RequestAction_container__5Hn+7`,
	"topSection": `RequestAction_topSection__-kUa6`,
	"exclamationCircleOrange": `RequestAction_exclamationCircleOrange__Mtzie`,
	"buttons": `RequestAction_buttons__fC9WE`,
	"rejectButton": `RequestAction_rejectButton__w09LY`,
	"approveButton": `RequestAction_approveButton__ZqJiF`
};
export default ___CSS_LOADER_EXPORT___;
